var React = require('react');

function SimCard (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14 23a2 2 0 00-2 2v13a2 2 0 002 2h18a2 2 0 002-2V25a2 2 0 00-2-2H14zm1 9v5h3v-5h-3zm0-3h12v8h4V26H15v3zm9 3h-3v5h3v-5z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.5 4A3.5 3.5 0 019 .5h18.557a3.5 3.5 0 012.715 1.29l9.442 11.6a3.5 3.5 0 01.786 2.209V44a3.5 3.5 0 01-3.5 3.5H9A3.5 3.5 0 015.5 44V4zM9 3.5a.5.5 0 00-.5.5v40a.5.5 0 00.5.5h28a.5.5 0 00.5-.5V15.599a.5.5 0 00-.112-.316L27.945 3.684a.5.5 0 00-.388-.184H9z","key":1})]);
}

SimCard.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SimCard;

SimCard.default = SimCard;
